import type { CrremPathwayScale } from "features/crrem-pathway-chart/model/types";

import { Stack } from "@mui/material";
import { CustomModal } from "components/CustomModal";
import { CrremPathwayScaleControl } from "features/crrem-pathway-chart/components/CrremPathwayScaleControl";
import { useTranslation } from "react-i18next";

import type { CrremSettings, EnergyAnalysisSettingsChange } from "../model/types";

import { EnergyAnalysisCorrectionSwitches } from "./EnergyAnalysisCorrectionSwitches";
import { EnergyAnalysisMetricSelect } from "./EnergyAnalysisMetricSelect";
import { EnergyAnalysisTrendMethodControl } from "./EnergyAnalysisTrendMethodControl";

type EnergyAnalysisSettingsModalProps = {
  disabled?: boolean;
  hideCorrectionSelection?: boolean;
  hideMetricSelection?: boolean;
  modalOpen: boolean;
  onSave: (settings: CrremSettings) => void;
  onScaleChange: (scale: CrremPathwayScale) => void;
  scale: CrremPathwayScale;
  setModalOpen: (open: boolean) => void;
  settings: CrremSettings;
};

export const EnergyAnalysisSettingsModal = ({
  disabled,
  hideCorrectionSelection,
  hideMetricSelection,
  modalOpen,
  onSave,
  onScaleChange,
  scale,
  setModalOpen,
  settings,
}: EnergyAnalysisSettingsModalProps) => {
  const { t } = useTranslation();
  const updateSettings: EnergyAnalysisSettingsChange = (key, value) => {
    onSave({ ...settings, [key]: value });
  };
  return (
    <CustomModal
      height="auto"
      modalOpen={modalOpen}
      padding="0.5rem 2.4rem 3.2rem 2.4rem"
      setModalOpen={setModalOpen}
      width="42rem"
    >
      <Stack className="w-full flex-col items-start gap-4 text-left">
        <h3 className="font-ds-headline-md flex min-h-[3.2rem] items-center pr-10 text-lds-foreground-heading-active">
          {t("BuildingProfile.energyAnalysis.settings.title")}
        </h3>
        <Stack className="w-full flex-col items-start gap-8 text-left">
        {hideMetricSelection ? null : (
          <EnergyAnalysisMetricSelect disabled={disabled} onChange={updateSettings} settings={settings} />
        )}
        <CrremPathwayScaleControl onChange={onScaleChange} value={scale} />
        <EnergyAnalysisTrendMethodControl disabled={disabled} onChange={updateSettings} settings={settings} />
        {hideCorrectionSelection ? null : (
          <EnergyAnalysisCorrectionSwitches disabled={disabled} onChange={updateSettings} settings={settings} />
        )}   
      </Stack>
      </Stack>
      </CustomModal>
  );
};
